import createIcon from '@/lib/create-icon'

const BaseballIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 36 36'
    fill='none'
  >
    <path
      d='M8.18919 30L30.835 13.034C33.4975 10.9632 33.7425 7.02754 31.3575 4.64251C28.9725 2.25748 25.0368 2.50251 22.9661 5.16495L6 27.8107'
      stroke='url(#paint0_linear_4795_734)'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M8.18919 30L30.835 13.034C33.4975 10.9632 33.7425 7.02754 31.3575 4.64251C28.9725 2.25748 25.0368 2.50251 22.9661 5.16495L6 27.8107'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M8.18919 30L30.835 13.034C33.4975 10.9632 33.7425 7.02754 31.3575 4.64251C28.9725 2.25748 25.0368 2.50251 22.9661 5.16495L6 27.8107'
      stroke='url(#paint1_radial_4795_734)'
      strokeOpacity='0.6'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M8.36752 32.7639C10.6205 29.6569 6.3685 25.3663 3.23584 27.6376C2.95144 27.8437 2.91892 28.2552 3.16738 28.5034L7.50022 32.8325C7.74895 33.0811 8.16115 33.0484 8.36752 32.7639Z'
      stroke='url(#paint2_linear_4795_734)'
      strokeWidth='2.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M8.36752 32.7639C10.6205 29.6569 6.3685 25.3663 3.23584 27.6376C2.95144 27.8437 2.91892 28.2552 3.16738 28.5034L7.50022 32.8325C7.74895 33.0811 8.16115 33.0484 8.36752 32.7639Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M8.36752 32.7639C10.6205 29.6569 6.3685 25.3663 3.23584 27.6376C2.95144 27.8437 2.91892 28.2552 3.16738 28.5034L7.50022 32.8325C7.74895 33.0811 8.16115 33.0484 8.36752 32.7639Z'
      stroke='url(#paint3_radial_4795_734)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15 25.5L10.5 21'
      stroke='url(#paint4_linear_4795_734)'
      strokeWidth='2.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15 25.5L10.5 21'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15 25.5L10.5 21'
      stroke='url(#paint5_radial_4795_734)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M27.75 31.5C25.6789 31.5 24 29.8211 24 27.75C24 25.6789 25.6789 24 27.75 24C29.8211 24 31.5 25.6789 31.5 27.75C31.5 29.8211 29.8211 31.5 27.75 31.5Z'
      stroke='url(#paint6_linear_4795_734)'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M27.75 31.5C25.6789 31.5 24 29.8211 24 27.75C24 25.6789 25.6789 24 27.75 24C29.8211 24 31.5 25.6789 31.5 27.75C31.5 29.8211 29.8211 31.5 27.75 31.5Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M27.75 31.5C25.6789 31.5 24 29.8211 24 27.75C24 25.6789 25.6789 24 27.75 24C29.8211 24 31.5 25.6789 31.5 27.75C31.5 29.8211 29.8211 31.5 27.75 31.5Z'
      stroke='url(#paint7_radial_4795_734)'
      strokeOpacity='0.6'
      strokeWidth='3'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_4795_734'
        x1='6'
        y1='3'
        x2='36.8652'
        y2='24.4342'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_4795_734'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(19.5 30) scale(13.5 13.7494)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_4795_734'
        x1='3'
        y1='27'
        x2='9.85886'
        y2='31.7632'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_4795_734'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(6 32.9999) scale(3 3.05538)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_4795_734'
        x1='10.5'
        y1='21'
        x2='15.6442'
        y2='24.5724'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_4795_734'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(12.75 25.5) scale(2.25 2.29157)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_4795_734'
        x1='31.5'
        y1='24'
        x2='22.9263'
        y2='29.9539'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_4795_734'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(27.75 31.5) rotate(180) scale(3.75 3.81928)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'BaseballIcon'
)

export default BaseballIcon
